import React from 'react'

const IconCalendar = ({ height, modifiers }) => {
  return (
    <svg
      className={`icon icon-capital ${modifiers}`}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 110 120"
      style={{height}}
    >
<g className="icon-bg">
	<circle fill="none" cx="55" cy="81.2" r="38.8"></circle>
</g>
<g className="fill-lcs-gold-web-4">
	<path d="M23.3,66.9l2.6,41.3c2,2.4,4.5,4.5,7.4,6.3l-2.6-40.4h48.6l-2.5,40c2.9-1.8,5.4-3.9,7.3-6.2l2.6-41H23.3z"></path>
	<path d="M22.8,63.3h64.3l1.4-15l-7.2,0l0,6c0,2.8-2.1,5.4-4.9,5.6c-3.2,0.3-6-2.2-6-5.4l0-1.1c0-1,0.8-1.7,1.7-1.7h0
		c1,0,1.7,0.8,1.7,1.7v0.9c0,1,0.7,1.9,1.6,2c1.2,0.2,2.3-0.7,2.3-1.9v-5.1c0,0,0,0,0,0v-1.2h0l0-3.7c0-1-0.7-1.9-1.6-2
		c-1.2-0.2-2.3,0.7-2.3,1.9v3.8l-34.4,0l0,6c0,2.8-2.1,5.4-4.9,5.6c-3.2,0.3-6-2.2-6-5.4l0-1.1c0-1,0.8-1.7,1.7-1.7h0
		c1,0,1.7,0.8,1.7,1.7l0,0.9c0,1,0.7,1.9,1.6,2c1.2,0.2,2.3-0.7,2.3-1.9v-5.1c0,0,0,0,0,0v-1.2h0l0-3.7c0-1-0.7-1.9-1.6-2
		c-1.2-0.2-2.3,0.7-2.3,1.9v3.8l-10.3,0l1,14.8L22.8,63.3z"></path>
	<g className="numbers">
		<path d="M38.3,97.6c0-6.3,2-11.3,8.2-11.3s8.2,5,8.2,11.3s-2,11.3-8.2,11.3S38.3,103.8,38.3,97.6z M49.3,97.6
			c0-3.5-0.6-6.4-2.7-6.4c-2.1,0-2.7,2.8-2.7,6.4c0,3.6,0.6,6.5,2.7,6.5C48.7,104,49.3,101.1,49.3,97.6z"></path>
		<path d="M57.1,104h4.6v-9.1c0-0.8,0-1.7,0-1.7h-0.1c0,0-0.3,0.6-0.9,1.2l-1.3,1.2l-3.1-3.3l5.9-5.5H67V104h4.7v4.6
			H57.1V104z"></path>
	</g>
</g>
</svg>
  )
}

IconCalendar.defaultProps = {
  height: "9rem",
  modifiers: ''
}

export default IconCalendar
